export const characterData = [
  {
    name: 'Carl',
    id: 'character-slot-first',
    vo: ['vo_char_carl_01', 'vo_char_carl_02', 'vo_char_carl_03', 'vo_char_carl_04'],
  },
  {
    name: 'Arugula/Forrest',
    id: 'character-slot-second',
    vo: ['vo_char_arugula_01', 'vo_char_arugula_02', 'vo_char_forrest_01', 'vo_char_forrest_02'],
  },
  {
    name: 'Sheldon',
    id: 'character-slot-third',
    vo: ['vo_char_sheldon_01', 'vo_char_sheldon_02', 'vo_char_nico_01', 'vo_char_nico_02'],
  },
  {
    name: 'Lotta',
    id: 'character-slot-fourth',
    vo: ['vo_char_lotta_01', 'vo_char_lotta_02'],
  },
];
